var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFontbold({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.872 17.432c2.256 0 4.048-.944 4.048-3.072 0-1.392-.816-2.176-1.872-2.448v-.064c.848-.32 1.36-1.328 1.36-2.256 0-2-1.68-2.592-3.84-2.592H8v10.432h3.872zm-.416-6.256h-1.104V8.824h1.12c1.104 0 1.632.304 1.632 1.12 0 .752-.496 1.232-1.648 1.232zm-1.104 4.432h1.328c1.28 0 1.936-.448 1.936-1.408 0-.912-.64-1.28-1.936-1.28h-1.328v2.688z"
  })));
}

export default SvgFontbold;